import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { TChargeUserType } from 'types';

import FlightMarkupForm from './Forms/FlightMarkupForm';
import HotelMarkupForm from './Forms/HotelMarkupForm';

export default function ManageMarkupB2B() {

    const navigate = useNavigate();

    const { service, userChargeType } = useParams<{ service: "flight" | "hotel", userChargeType: TChargeUserType }>();


    useEffect(() => {
        console.log(service);
        if (service !== 'flight' && service !== 'hotel') {
            navigate(-1);
        }
    }, [service]);


    return (
        service === 'flight' ? <FlightMarkupForm /> : <HotelMarkupForm />
    );

}